import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const Main7SectionWrap = styled.div`
  height: 1056px;
  display: block;
  //margin-bottom: 130px;

  > div {
    width: 1100px;
    margin: 184px auto 0 auto;
    display: flex;
    justify-content: space-between;
  }

  ${customMedia.lessThan('tablet')`
    height:796px;
    width: 328px;
    margin: 100px auto 100px auto;
    >div{
      width: 100%;
      margin: 30px 0 60px 0 ;
    }
    >section{
      width: 277px;
      display: flex;
      margin: 0 auto;
      justify-content: space-between;
     }
`}
`
const Main7SectionTabBtn = styled.button`
  border-radius: 20px;
  padding: 8px 20px;
  border: none;
  color: ${(props) => (props.color === 'active' ? COLOR.white : COLOR.gray90)};
  background: ${(props) => (props.color === 'active' ? COLOR.gray90 : COLOR.gray10)};
  font-size: 16px;
  line-height: 23px;
  font-family: NotoSansBold, sans-serif;
`

const Main7LeftContent = styled.div`
  width: 360px;
  display: block;
  height: 680px;
  border-radius: 32px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.08);

  > div {
    height: 56px;
    width: 100%;
    display: flex;
    text-align: center;
    border-bottom: 1px solid ${COLOR.blueGray1};

    > p {
      margin: 0 107px 0 139px;
      font-size: 16px;
      line-height: 56px;
      font-family: NotoSansBold, sans-serif;
      color: #2a292e;
    }

    > img {
      margin: 21.5px 0 21.5px 0;
      display: flex;
      width: 13px;
      height: 13px;
    }
  }

  ${customMedia.lessThan('tablet')`
    width: 328px;
    margin: 0 auto;
    height: 619px;
    border-radius: 30px;
    >div{
    height: 51px;
     >p{
        margin: 0 95px 0 125px;
     }
    }
`}
`
const Main7LeftTopTab = styled.section`
  margin: 20px auto 33px auto;
  width: 100%;
  display: flex;
  height: 28px;
  justify-content: center;

  .active {
    background: ${COLOR.point4};
    color: ${COLOR.point1};
  }

  > span {
    font-size: 14px;
    font-family: NotoSansMedium, sans-serif;
    padding: 0 12px;
    display: inline-block;
    height: 28px;
    background: ${COLOR.gray10};
    border-radius: 16px;
    line-height: 28px;
    color: ${COLOR.gray50};
    margin-right: 8px;
  }

  ${customMedia.lessThan('tablet')`
    margin: 17px auto 29px auto;
    height: 27px;
    >span {
      padding: 0 10px;
      height: 27px;
      line-height: 27px;
    }
`}
`
const Main7LeftMiddleContent = styled.section`
  height: 256px;
  display: block;
  text-align: center;

  > span {
    margin: 0 0 30px 0;
    display: inline-block;
    border-radius: 100px;
    width: 160px;
    height: 160px;
    background: ${COLOR.gray10};

    > img {
      display: flex;
      line-height: 160px;
      margin: 23.5px auto 23.5px auto;
      width: 112px;
      height: 112px;
    }
  }

  > div {
    display: flex;
    margin: 0 auto;
    width: 72px;
    justify-content: space-between;

    img {
      display: flex;
      width: 32px;
      height: 32px;
    }
  }

  ${customMedia.lessThan('tablet')`
   height: 233px;
   > span{
      margin: 0 0 27px 0;
      width: 145px;
      height: 145px;
      >img{
        line-height:145px;
        width: 105px;
        height: 105px;
        margin: 20px auto 20px auto;
      }
   }
   >div{
     width: 65px;
     >img{
       width: 29px;
       height: 29px;
     }
   }
`}
`
const Main7LeftBottomContent = styled.section`
  height: 280px;

  > pre {
    padding: 0 19px;
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    font-family: NotoSansRegular, sans-serif;
    white-space: pre-wrap;
  }

  ${customMedia.lessThan('tablet')`
    height: 234px;
    >pre{
      padding: 0 18px;
      font-size: 12px;
      line-height: 18px;    
    }
`}
`
const Main7RightContent = styled.div`
  width: 684px;
  height: 684px;
  display: grid;
  flex-wrap: wrap;
  justify-content: space-between;
  grid-template-columns: 156px 156px 156px 156px;
  gap: 20px;
  margin: 0 0 44px 0;
  .active {
    background: ${COLOR.point3};
  }

  section:hover {
    background: ${COLOR.point3};
  }

  > section {
    height: 156px;
    border-radius: 100px;
    background: ${COLOR.point2};
    cursor: pointer;

    > img {
      display: flex;
      line-height: 156px;
      margin: 21.5px auto 21.5px auto;
      width: 112px;
      height: 112px;
    }
  }

  ${customMedia.lessThan('tablet')`
   display: none;
`}
`

export {
  Main7LeftBottomContent,
  Main7LeftContent,
  Main7LeftMiddleContent,
  Main7LeftTopTab,
  Main7RightContent,
  Main7SectionTabBtn,
  Main7SectionWrap,
}
